import React, { useEffect, useState } from 'react';
import { getInitialAndColor } from '../utils/AvatarUtils';

const Avatar = ({ name = '', profileImage = null, className = '' }) => {
  const [imageError, setImageError] = useState(!profileImage);
  const { initial, bgColor } = getInitialAndColor(name);

  useEffect(() => {
    setImageError(!profileImage);
  }, [profileImage]);

  return (
    <div className={`rounded-full overflow-hidden select-none ${className}`}>
      {!imageError ? (
        <img
          src={profileImage}
          alt={name ? `${name}'s profile` : 'Profile'}
          className="w-full h-full object-cover"
          onError={() => setImageError(true)}
        />
      ) : (
        <div
          className={`flex items-center justify-center w-full h-full ${bgColor} text-white font-bold text-center`}
        >
          {initial}
        </div>
      )}
    </div>
  );
};

export default Avatar;
